import { memo } from 'react';
import Box from '../Box/Box';
import Text from '../Text/Text';
import { InfoProps } from './Info.types';

function Info({ title, description, locNS, textAlign, ...rest }: InfoProps) {
  return (
    <Box gap="space-400" {...rest}>
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        textAlign={textAlign}
        locKey={title}
        locNS={locNS}
      />
      <Text
        variant="body-s"
        color="darkSurfacePrimary"
        textAlign={textAlign}
        locKey={description}
        locNS={locNS}
      />
    </Box>
  );
}

export default memo(Info);
